import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeSpace',
  standalone: false
})
export class RemoveSpacePipe implements PipeTransform {

  transform(value: string): string {
    return value.replace(/\s/g, '');
  }

}
